export default __webpack_public_path__ + "static/media/15.b1b774c5.jpg";